function success(success) {
    const Logger = nibara.logger;
    Logger.debug(success);
}

function error(error) {
    const Logger = nibara.logger;
    Logger.debug(error);
}

function getPushStatusChecker(url, cb) {
    let id = "pushStatusChecker";
    let psc = document.querySelector("#" + id);
    if (psc) {
        return cb(psc);
    }

    psc = document.createElement("iframe");
    psc.src = url;
    psc.id = id;
    psc.style.display = "none";
    document.body.appendChild(psc);
    setTimeout(function() {
        cb(psc);
    }, 2000);
    setTimeout(function() {
        psc.parentNode.removeChild(psc);
    }, 4000);
}

export function checkPushStatus(url, cb) {
    getPushStatusChecker(url, function(psc) {

        let prevHandler = window.onmessage;
        let response;
        window.onmessage = function(e) {
            if(typeof e.data === "object"){
                response = Object.assign({}, e.data);
            }else{
                response = {
                    permission: false
                }
            }
            window.onmessage = prevHandler;
            cb(response);
        };
        psc.contentWindow.postMessage("checkPushStatus", "*");
    });
}

export function subscribeToChannels(channels, success, error){
    success = (typeof success == 'function') ? success : function(){};
    error = (typeof error == 'function') ? error : function(){};
    navigator.indigitall.subscribe(channels, success, error);
}

export function indigitalLoad(app, document) {
    const Logger = nibara.logger;
    var chromeVersion = getChromeVersion();
    Logger.debug("[indigitall] Chrome Version: ",chromeVersion);
    if (chromeVersion > 41) {
        app.load('/indigitall/sdk.min.js?v=20200518110000').then(() => {
            var host = window.location.host;
            var appKey = '';
            if (host.indexOf('sevilla.abc.es') > -1) {
                appKey = '1213247813562e12bccb8137.99837995';
            } else if (host.indexOf('lavozdigital.es') > -1) {
                appKey = '2064175608562e537c6e2369.80569469';
            } else {
                appKey = '18484694655613f1f2334409.61215592';
            }
            Logger.debug("[indigitall] appKey: ", appKey);

            indigitall.init({
                appKey: appKey,
                workerPath: '/indigitall/worker.min.js?v=20200518110000',
                requestLocation: true,
                setDebugLog: true,
                onInitialized: onIndigitallInitialized,
                requestPushPermission: requestPushPermission,
                requestLocationPermission: requestLocationPermission,
                onLocationUpdated: onLocationUpdated,
                onError: onError
            });
        });
    }
}

function getChromeVersion () {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : false;
}

function onIndigitallInitialized(permissions,device){
    const Logger = nibara.logger;
    Logger.debug("[indigitall] Push Permission: ",permissions.push);
    Logger.debug("[indigitall] Location Permission: ",permissions.location);
    Logger.debug("[indigitall] Device: ", device);

    Voonto.ready.then(function (app) {
        app.when('vocuser:userinterestdata').then(function (response) {
            Logger.debug('[indigitall] vocuser:userinterestdata: ' + response);
            var InteresGroupAdd = [];
            var InteresGroupDelete = [];
            //Verificamos si existe.
            if (response.responseUserInterestData) {
                Logger.debug('[indigitall] response.responseUserInterestData: ' + response.responseUserInterestData);
                if (response.responseUserInterestData.length > 0) {
                    //Recorremos los intereses
                    response.responseUserInterestData.forEach(function (element) {
                        //Miramos si es activo o no
                        if (element.status == true)
                            InteresGroupAdd.unshift(element.ID.replace(".", ""));
                        else
                            InteresGroupDelete.unshift(element.ID.replace(".", ""));
                    });
                    //Validamos y eliminamos o añadimos al grupo.
                    if (InteresGroupAdd.length > 0) {
                        indigitall.topicsSubscribe(InteresGroupAdd, function (response) {
                            Logger.debug('[indigitall] InteresGroupAdd::' + response);
                        }, function (response) {
                            Logger.debug('[indigitall] InteresGroupAdd::' + response);
                        });
                    }
                    if (InteresGroupDelete.length > 0)
                        indigitall.topicsUnsubscribe(InteresGroupDelete, function (response) {
                            Logger.debug('[indigitall] InteresGroupDelete::' + response);
                        }, function (response) {
                            Logger.debug('[indigitall] InteresGroupDelete::' + response);
                        });
                }
            }
        });

        app.when('vocuser:ready').then(function (gigyaux) {
            Logger.debug('[indigitall] vocuser:ready: ' + gigyaux);
            if (gigyaux.getUserType() === "registrado") {
                Logger.debug('[indigitall] gigyaux.getUserType: ' + gigyaux.getUserType());
                indigitall.topicsSubscribe(['registrado'], function (response) {
                    Logger.debug('[indigitall] RegistradoAdd::' + response);
                }, function (response) {
                    Logger.debug('[indigitall] RegistradoAdd::' + response);
                });
                indigitall.setExternalCode(gigyaux.vocUserGetData('uid'), (device) => {
                    Logger.debug('[indigitall] setExternalCode: ok usuario registrado: ' + device);
                }, (error) => {
                    Logger.debug('[indigitall] setExternalCode: error usuario registrado:' + error);
                });

            } else {
                Logger.debug('[indigitall] gigyaux.getUserType: ' + gigyaux.getUserType());
                indigitall.topicsUnsubscribe(['registrado'], function (response) {
                    Logger.debug('[indigitall] RegistradoDelete::' + response);
                }, function (response) {
                    Logger.debug('[indigitall] RegistradoDelete::' + response);
                });

                indigitall.setExternalCode("", (device) => {
                    Logger.debug('[indigitall] setExternalCode: ok usuario anonimo: ' + device);
                }, (error) => {
                    Logger.debug('[indigitall] setExternalCode: error usuario anonimo:' + error);
                });

            }
        });

        let pathName = window.location.pathname;
        Logger.debug('[indigitall] pathName: ' + pathName);
        if (/^\/agronoma/.test(pathName)) {
            Logger.debug('[indigitall] topicsList and agronoma user interests');
            indigitall.topicsList((topics) => {
                var DeleteTopics = [];
                topics.forEach((topic) => {
                    if (topic.subscribed)
                    //AGR y GAN son las categorias de Agricultura y Ganaderia.
                        if (topic.code.substring(0, 3) == "AGR" || topic.code.substring(0, 3) == "GAN")
                            DeleteTopics.push(topic.code);
                });
                if (DeleteTopics.length > 0) indigitall.topicsUnsubscribe(DeleteTopics);
            });

            agronoma_user_interests.then(
                function (result) {
                    Logger.debug('[indigitall] result.interests: '  + result.interests);
                    var Resultado = [];
                    if ("undefined" != typeof result.interests && null != result.interests) {
                        Resultado = Object.values(result.interests);
                    }

                    var InsertTopics = [];
                    Resultado.forEach((Intereses) => {
                        var Scopes = [];
                        if (Array.isArray(Intereses.scopes))
                            Scopes = Intereses.scopes;
                        else
                            Scopes = Object.values(Intereses.scopes);

                        Scopes.forEach((Ambito) => {
                            InsertTopics.push((Intereses.code + Ambito.id).replace(".", ""));
                        });
                    });

                    if (InsertTopics.length > 0) indigitall.topicsSubscribe(InsertTopics);
                }
            )
        }
    });
}

function onLocationUpdated(location){
    const Logger = nibara.logger;
    Logger.debug("[indigitall] Location\n \t - Latitude:"+location.coords.latitude+"\n \t - Longitude: "+ location.coords.longitude);
}

function onError(error){
    const Logger = nibara.logger;
    Logger.debug('[indigitall] error: ' + error);
}

function requestPushPermission(permission){
    const Logger = nibara.logger;
    Logger.debug("[indigitall] RequestPushPermission: "+permission.state);
}

function requestLocationPermission(permission){
    const Logger = nibara.logger;
    Logger.debug("[indigitall] RequestLocationPermission: "+permission.state);
}


// WEBPACK FOOTER //
// ./src/scripts/layout/push-notification-indigitall.js